module.exports = [
  function() {
    return {
      DEFERRED: -5,
      FLAGGED: -3,
      UNREAD: -2,
      VIP: -1,
      MAIL: 1,
      DRAFT: 2,
      SENT: 3,
      TRASH: 4,
      SPAM: 5,
      VIRUS: 6
    }
  }
]



// WEBPACK FOOTER //
// ./src/js/mail/MailFolderType.js